<template>
  <div v-if="attributes">
    <SfProperty
      class="m-b-5"
      v-for="attribute in visibleAttributes"
      :key="attribute"
      :name="$t(attribute)"
      :value="$t(attributes[attribute].join(', '))"
    />
  </div>
</template>
<script>
import { SfProperty } from '@storefront-ui/vue';
import _ from 'lodash';

export default {
  name: 'ProductAttributes',
  components: {
    SfProperty,
  },
  props: {
    attributes: {
      type: Object,
      required: true,
    },
  },
  computed: {
    visibleAttributes() {
      const omitList = ['Repair info', 'Reach info'];

      const omitedAttrs = _.omit(this.attributes, omitList);
      return Object.keys(omitedAttrs).filter((attr) => omitedAttrs[attr].length);
    },
  },
};
</script>
